import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [moreOpen, setMoreOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const moreRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClick = () => {
    setMoreOpen(false);
    setMobileOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <Link to="/" className="nav-brand" onClick={handleClick}>
          <img src="/assets/NC_New_LOGO.png" alt="Nexus Concordat" className="nav-brand-icon" />
        </Link>

        <button
          className={`nav-mobile-toggle ${mobileOpen ? 'active' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links ${mobileOpen ? 'open' : ''}`}>
          <a href="/dawn/" onClick={handleClick}>Newsletter</a>
          <Link to="/fund-us" className="nav-cta" onClick={handleClick}>Fund Us</Link>
          <Link to="/" onClick={handleClick}>Home</Link>
          <Link to="/about" onClick={handleClick}>About</Link>
          <Link to="/meet-us" onClick={handleClick}>Meet Us</Link>
          <Link to="/careers" onClick={handleClick}>Careers</Link>
          <Link to="/gnul" onClick={handleClick}>Gnul</Link>

          <div className="nav-more" ref={moreRef}>
            <button
              className={`nav-more-toggle ${moreOpen ? 'active' : ''}`}
              onClick={() => setMoreOpen(!moreOpen)}
              aria-label="More pages"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div className={`nav-more-menu ${moreOpen ? 'visible' : ''}`}>
              <Link to="/portfolio" onClick={handleClick}>Portfolio</Link>
              <Link to="/philosophy" onClick={handleClick}>Philosophy</Link>
              <Link to="/contact" onClick={handleClick}>Contact</Link>
            </div>
          </div>

          <div className="nav-mobile-extra">
            <Link to="/portfolio" onClick={handleClick}>Portfolio</Link>
            <Link to="/philosophy" onClick={handleClick}>Philosophy</Link>
            <Link to="/contact" onClick={handleClick}>Contact</Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
